import { AccessLevel } from '../../../../types';
import { i18n } from '../../../helpers/i18n';

export const getAccessLevelChangeNotification = (accessLevel: AccessLevel, isWaitingRoomEnabled: boolean) => {
    let text = '';
    let icon;

    switch (accessLevel) {
        case AccessLevel.PUBLIC:
            icon = isWaitingRoomEnabled ? undefined : 'insecurity';
            text = isWaitingRoomEnabled
                ? i18n('statuses', 'notification-conference-access-level-waiting-room-public')
                : i18n('statuses', 'notification-conference-access-level-public');
            break;
        case AccessLevel.ORGANIZATION:
            icon = isWaitingRoomEnabled ? undefined : 'security';
            text = isWaitingRoomEnabled
                ? i18n('statuses', 'notification-conference-access-level-waiting-room-organization')
                : i18n('statuses', 'notification-conference-access-level-organization');
            break;
        case AccessLevel.ADMINS:
            text = i18n('statuses', 'notification-conference-access-level-waiting-room-admins');
            break;
    }

    return { icon, text };
};
